"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationEventRole = void 0;
var create_entity_1 = require("../../utils/create-entity");
var entity_organisation_role_card_1 = require("../../components/entities/entity-organisation-role-card");
exports.OrganisationEventRole = {
  name: 'OrganisationEventRole',
  table: {
    fieldNames: ["event", "organisation", "role"]
  },
  autoRoutes: ['create', 'update', 'list', 'details'],
  components: {
    card: entity_organisation_role_card_1.EntityOrganisationRoleCard
  },
  list: {},
  details: {},
  form: {
    bufferAtEnd: 280,
    modal: {
      maxWidth: '800px'
    },
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      event: {
        type: 'linked',
        entityTypeName: 'Event',
        variant: 'forOrganisation',
        required: true
      },
      organisation: {
        type: 'linked',
        entityTypeName: 'Organisation',
        variant: 'forEvent',
        required: true
      },
      role: {
        type: 'linked',
        entityTypeName: 'Role',
        required: true
      }
    })
  }
};